import { put } from 'redux-saga/effects';
import axios from '../axios/axios-commission-splits';
import axiosCRM from 'store/axios/axios-crm';
import * as actions from '../actions/commission_splits';

export function* getCommissionSplitsSaga(action) {
    yield put(actions.getCommissionSplitsStart());
    try {
        if (action.data?.id) {
            const own = action.data.own ? '&own=true' : '';
            const response = yield axios.get('/entries?id='+action.data+own);
            yield put(actions.getCommissionSplitsSuccess(response.data));
        } else if (action.data?.assoc_combined) {
            const open_statuses = action.data.open_statuses || [];
            const own_statuses = action.data.own_statuses || [];
            const use_pending_agent_approval = !!action.data.use_pending_agent_approval;
            const merged = [];
            const seen = new Set();
            const pushAll = (rows) => {
                (rows || []).forEach(row => {
                    if (row && row.id != null && !seen.has(row.id)) {
                        seen.add(row.id);
                        merged.push(row);
                    }
                });
            };
            if (use_pending_agent_approval) {
                const rPa = yield axios.get('/entries?status=8&pending_agent_approval=true');
                pushAll(rPa && rPa.data);
            }
            if (open_statuses.length > 0) {
                const r1 = yield axios.get('/entries?status=' + open_statuses.join(','));
                pushAll(r1 && r1.data);
            }
            if (own_statuses.length > 0) {
                const r2 = yield axios.get('/entries?status=' + own_statuses.join(',') + '&own=true');
                pushAll(r2 && r2.data);
            }
            console.log('[CS ALL combined] open:', open_statuses, 'own:', own_statuses, 'use_pending_agent_approval:', use_pending_agent_approval, 'merged count:', merged.length);
            yield put(actions.getCommissionSplitsSuccess(merged));
        } else {
          console.log('getting entries', action);
            const pending_agent = action.data.pending_agent_approval ? '&pending_agent_approval=true' : '';
            const own = action.data.own ? '&own=true' : '';
            const response = yield axios.get('/entries?status='+action.data.status+own+pending_agent);
            yield put(actions.getCommissionSplitsSuccess(response.data));
        }
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
              return yield put(actions.getCommissionSplitsFail(e.response.data));
            }
          }
        yield put(actions.getCommissionSplitsFail(e));
    }
}

export function* createCommissionSplitSaga(action) {
    yield put(actions.createCommissionSplitStart());
    try {
        const response = yield axios.post('/entry', action.data);
        yield put(actions.createCommissionSplitSuccess(response.data));
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
              return yield put(actions.createCommissionSplitFail(e.response.data));
            }
          }
        yield put(actions.createCommissionSplitFail(e));
    }
}

export function* deleteCommissionSplitSaga(action) {
    yield put(actions.deleteCommissionSplitStart());
    try {
        const response = yield axios.delete('/entry?id='+action.data);
        yield put(actions.deleteCommissionSplitSuccess(response.data));
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
              return yield put(actions.deleteCommissionSplitFail(e.response.data));
            }
          }
        yield put(actions.deleteCommissionSplitFail(e));
    }
}

export function* updateCommissionSplitSaga(action) {
    yield put(actions.updateCommissionSplitStart());
    try {
        const dat = action.data;
        console.log('update dat', dat);
        const response = yield axios.put('/entry', action.data);
        yield put(actions.updateCommissionSplitSuccess(response.data));
        if (dat.status === 13) {
          const csId = dat.id;
          const copyFailures = [];

          const tryCopy = function* (label, endpoint, payload) {
            try {
              const resp = yield axiosCRM.post(endpoint, payload);
              const insertId = resp && resp.data ? resp.data.insertId : null;
              if (insertId == null) {
                console.warn(`[CS ${csId} copy] ${label} returned no insertId (duplicate, already-illi, not-found, or silent backend failure)`, resp && resp.data);
              } else {
                console.log(`[CS ${csId} copy] ${label} → illi insertId ${insertId}`);
              }
              return resp;
            } catch (e) {
              const msg = e && e.response && e.response.data ? e.response.data : (e && e.message) || e;
              copyFailures.push({ label, endpoint, payload, error: msg });
              console.error(`[CS ${csId} copy FAILED] ${label}`, msg);
              return null;
            }
          };

          yield* tryCopy(`property ${dat.property_id}`, "/property_copy", {
            id: dat.property_id,
            spaces_indexes_to_copy: [],
          });

          if (dat.json_data) {
            const json = JSON.parse(dat.json_data);
            if (json.referrals) {
              for (let i = 0; i < json.referrals.length; i++) {
                const jr = json.referrals[i];
                if (jr.contact_id) {
                  yield* tryCopy(`referral[${i}] ${jr.contact_id}`, "/contact_copy", { id: jr.contact_id });
                }
                if (jr.company_id) {
                  yield* tryCopy(`referral[${i}].company ${jr.company_id}`, "/company_copy", { id: jr.company_id });
                }
              }
            }
            if (json.outside_brokers) {
              for (let i = 0; i < json.outside_brokers.length; i++) {
                const jr = json.outside_brokers[i];
                if (jr.contact_id) {
                  yield* tryCopy(`outside_broker[${i}] ${jr.contact_id}`, "/contact_copy", { id: jr.contact_id });
                }
                if (jr.company_id) {
                  yield* tryCopy(`outside_broker[${i}].company ${jr.company_id}`, "/company_copy", { id: jr.company_id });
                }
              }
            }
          }

          if (copyFailures.length > 0) {
            console.error(`[CS ${csId}] ${copyFailures.length} copy operation(s) threw errors on finalization:`, copyFailures);
          }
        }
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
              return yield put(actions.updateCommissionSplitFail(e.response.data));
            }
          }
        yield put(actions.updateCommissionSplitFail(e));
    }
}

export function* getCommissionSplitsPropertyExistenceSaga(action) {
    yield put(actions.getCommissionSplitsPropertyExistenceStart());
    try {
        const response = yield axios.get('/entries?property_id='+action.data);
        yield put(actions.getCommissionSplitsPropertyExistenceSuccess(response.data));
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
              return yield put(actions.getCommissionSplitsPropertyExistenceFail(e.response.data));
            }
          }
        yield put(actions.getCommissionSplitsPropertyExistenceFail(e));
    }
}

export function* createCommissionSplitsHistorySaga(action) {
    yield put(actions.createCommissionSplitsHistoryStart());
    try {
        for (let i = 0; i < action.data.length; i++) {
            const ad = action.data[i];
            yield axios.post('/history', ad);
        }
        if (action.notifications) {
          for (let i = 0; i < action.notifications.length; i++) {
            const an = action.notifications[i];
            yield axios.post('/send_notification', an);
          }
        }
        yield put(actions.createCommissionSplitsHistorySuccess('Success'));
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
              return yield put(actions.createCommissionSplitsHistoryFail(e.response.data));
            }
          }
        yield put(actions.createCommissionSplitsHistoryFail(e));
    }
}

export function* getCommissionSplitsHistorySaga(action) {
    yield put(actions.getCommissionSplitsHistoryStart());
    try {
        const response = yield axios.get('/history?cs_id='+action.data);
        yield put(actions.getCommissionSplitsHistorySuccess(response.data));
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
              return yield put(actions.getCommissionSplitsHistoryFail(e.response.data));
            }
          }
        yield put(actions.getCommissionSplitsHistoryFail(e));
    }
}

export function* getCommissionSplitsReviewersSaga(action) {
    yield put(actions.getCommissionSplitsReviewersStart());
    try {
        const response = yield axios.get('/reviewers');
        yield put(actions.getCommissionSplitsReviewersSuccess(response.data));
    } catch (e) {
        if (e.response) {
            if (e.response.data) {
              return yield put(actions.getCommissionSplitsReviewersFail(e.response.data));
            }
          }
        yield put(actions.getCommissionSplitsReviewersFail(e));
    }
}

export function* createCommissionSplitsPdfSaga(action) {
  yield put(actions.createCommissionSplitsPdfStart());
  try {
      const response = yield axios.post('/pdf', action.data);
      yield put(actions.createCommissionSplitsPdfSuccess(response.data));
  } catch (e) {
      if (e.response) {
          if (e.response.data) {
            return yield put(actions.createCommissionSplitsPdfFail(e.response.data));
          }
        }
      yield put(actions.createCommissionSplitsPdfFail(e));
  }
}

export function* getCommissionSplitsApproversSaga(action) {
  yield put(actions.getCommissionSplitsApproversStart());
  try {
      const response = yield axios.get('/approvers');
      yield put(actions.getCommissionSplitsApproversSuccess(response.data));
  } catch (e) {
      if (e.response) {
          if (e.response.data) {
            return yield put(actions.getCommissionSplitsApproversFail(e.response.data));
          }
        }
      yield put(actions.getCommissionSplitsApproversFail(e));
  }
}

export function* getCsSigningUrlSaga(action) {
  yield put(actions.getCsSigningUrlStart());
  try {
      const response = yield axios.get('/signing_url?id='+action.data);
      yield put(actions.getCsSigningUrlSuccess(response.data));
  } catch (e) {
      if (e.response) {
          if (e.response.data) {
            return yield put(actions.getCsSigningUrlFail(e.response.data));
          }
        }
      yield put(actions.getCsSigningUrlFail(e));
  }
}

export function* getCommissionSplitSaga(action) {
  yield put(actions.getCommissionSplitStart());
  try {
      const response = yield axios.get('/entry?id='+action.data);
      yield put(actions.getCommissionSplitSuccess(response.data));
  } catch (e) {
      if (e.response) {
          if (e.response.data) {
            return yield put(actions.getCommissionSplitFail(e.response.data));
          }
        }
      yield put(actions.getCommissionSplitFail(e));
  }
}

